import SlackChannelIcon from "@uui/Hash02";
import EmailIcon from "@uui/Mail01";
import TeamsChannelIcon from "@uui/MessageChatSquare";
import MessagesIcon from "@uui/MessageTextSquare02";

import type { TopicChannelProvider } from "@app/analytics/types";

export const CHANNEL_OPTS_FOR_TOPIC_PROVIDER: {
  [key in TopicChannelProvider]?: {
    Icon: typeof SlackChannelIcon;
    channelPrefix?: string;
    sourceLabel: string;
    sourceLabelShort: string;
  };
} = {
  google_email: {
    Icon: EmailIcon,
    sourceLabel: "email thread",
    sourceLabelShort: "thread",
  },
  microsoft_graph_email: {
    Icon: EmailIcon,
    sourceLabel: "email thread",
    sourceLabelShort: "thread",
  },
  microsoft_graph_teams_chat_ingest: {
    Icon: TeamsChannelIcon,
    sourceLabel: "Teams channel",
    sourceLabelShort: "channel",
  },
  slack_ingest: {
    Icon: SlackChannelIcon,
    channelPrefix: "#",
    sourceLabel: "Slack channel",
    sourceLabelShort: "channel",
  },
};

export const MESSAGE_OPTS_FOR_TOPIC_PROVIDER: {
  [key in TopicChannelProvider]?: {
    Icon: typeof SlackChannelIcon;
    sourceLabel: string;
    sourceLabelShort: string;
  };
} = {
  google_email: {
    Icon: EmailIcon,
    sourceLabel: "email",
    sourceLabelShort: "email",
  },
  microsoft_graph_email: {
    Icon: EmailIcon,
    sourceLabel: "email",
    sourceLabelShort: "email",
  },
  microsoft_graph_teams_chat_ingest: {
    Icon: MessagesIcon,
    sourceLabel: "Teams message",
    sourceLabelShort: "message",
  },
  slack_ingest: {
    Icon: MessagesIcon,
    sourceLabel: "Slack message",
    sourceLabelShort: "message",
  },
};
